import React from "react";
import { navigate } from "gatsby";

import ArticleCard from "../cards/articleCard";
import { ConditionalSwiper } from "../shared/conditionalSwiper";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";
import BackgroundImgDark from "images/relatedBg.svg";
import BackgroundImgLight from "images/article/featured-bg.png";

export const FindOther = ({ articles }) => {
  const breakpoint = useBreakpoint();
  return (
    <section className="bg-transparent flex flex-col items-center justify-center mx-auto relative z-10">
      <div
        className={`w-full z-0 top-0 bottom-0 absolute right-0 left-0 bg-cover bg-no-repeat bg-center hidden planet:block planet:opacity-40`}
        style={{
          backgroundImage: `url('${BackgroundImgDark}')`
        }}
      />
      <div
        className={`w-full z-0 top-0 bottom-0 absolute right-0 left-0 bg-cover bg-no-repeat bg-center planet:hidden`}
        style={{
          backgroundImage: `url('${BackgroundImgLight}')`
        }}
      />

      <div className="w-11/12 sm:w-full sm:h-full z-10 m-0 flex flex-col items-center">
        <div className="sm:absolute sm:-translate-y-1/2 flex flex-col sm:w-8/12 mr-auto md:m-0">
          <div className="flex flex-col w-full justify-center sm:mx-auto pt-14 pb-8 sm:pr-0 sm:py-2 sm:h-24 sm:bg-yellow-light sm:planet:bg-gray-darker">
            <h1
              className="font-light text-left text-title font-normal sm:text-center sm:text-[38px] leading-8"
              dangerouslySetInnerHTML={{
                __html: "Find something else"
              }}
            />
          </div>
        </div>

        <div className="flex flex-col w-full sm:w-10/12 mx-auto pt-1 sm:pt-32 pb-10 sm:pb-16">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-4 pb-10">
            <ConditionalSwiper
              condition={breakpoint === "xs"}
              slidesPerView={1.25}
              spaceBetween={10}
              centeredSlides={false}
              className="w-full h-full"
            >
              {articles &&
                articles.length > 0 &&
                articles.map((article, idx) => (
                  <div className="flex flex-col rounded-md" key={idx}>
                    <ArticleCard article={article} type="program" />
                  </div>
                ))}
            </ConditionalSwiper>
          </div>

          <button
            className="submit-button group flex justify-center items-center w-full md:w-auto py-2 px-12 md:mx-auto planet:hover:bg-white"
            onClick={() => navigate("/find-a-program")}
          >
            <p className="text-white planet:text-gray-darker planet:group-hover:text-gray-darker  font-bold pr-2">
              Find a program
            </p>
            <ArrowRightIcon className="stroke-white planet:stroke-gray-darker planet:group-hover:stroke-gray-darker" />
          </button>
        </div>
      </div>
    </section>
  );
};
